// Auth0ProviderWrapper.tsx (no useNavigate)
import React from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { getEnvironment } from '../managers/EnvironmentManager';

type EnvKey = 'localhost' | 'dev' | 'prod';

const AUTH0_DOMAIN = {
    localhost: 'wallscapes.us.auth0.com',
    dev: 'wallscapes.us.auth0.com',
    prod: 'wallscapes.us.auth0.com'
} as const;
const AUTH0_CLIENT_ID = {
    localhost: 'z9OnkPB1hrkDNQCF9iQHs93x73j8g7j0',
    dev: 'z9OnkPB1hrkDNQCF9iQHs93x73j8g7j0',
    prod: 'qkBtWMC5imycy6iOKdb04arGmIFdD4Vt'
} as const;
const AUTH0_AUDIENCE = {
    localhost: 'https://api.wallscapes.ai/dev',
    dev: 'https://api.wallscapes.ai/dev',
    prod: 'https://api.wallscapes.ai/prod'
} as const;

const Auth0ProviderWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
    const env = getEnvironment() as EnvKey;

    return (
        <Auth0Provider
            domain={AUTH0_DOMAIN[env]}
            clientId={AUTH0_CLIENT_ID[env]}
            authorizationParams={{
                redirect_uri: window.location.origin + '/callback',
                audience: AUTH0_AUDIENCE[env],
            }}
            onRedirectCallback={(appState?: AppState) => {
                const target = appState?.returnTo || '/';
                // Replace current browser entry (/callback) with target
                window.history.replaceState({}, '', target);
            }}
        >
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWrapper;
